import {RecordForm} from '../forms/RecordForm';


import {useAccountApplication} from '../hooks/useAccountApplication';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {useUserAccount} from "../../../../hooks/useUserAccount.ts";


export const AddPage = () => {

    const {userAccount} = useUserAccount()

    if (!userAccount) {
        throw new Error('user account is required parameter')
    }

    const {
        createRecord,
    } = useAccountApplication(userAccount.id);

    return (
        <FormPageLayout
            title='Add User Application'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
